
module.exports.getItemModelTotalPrice = function(itemModel)
{
    var totalPrice = itemModel.item.price;
    itemModel.modifierGroupModels.forEach (modifierGroupModel =>
    {
        totalPrice = totalPrice + this.getModifierGroupModelTotalPrice(modifierGroupModel);
    });

    return totalPrice * itemModel.quantity;
}

module.exports.getModifierGroupModelTotalPrice = function(modifierGroupModel)
{
    var modifierGroupTotalPrice = 0;
    modifierGroupModel.modifierModels.forEach(modifierModel =>
    {
        var totalPrice = modifierModel.modifier.price;

        modifierModel.modifierGroupModels.forEach (modifierSubGroupModel =>
        {
            totalPrice = totalPrice + this.getModifierGroupModelTotalPrice(modifierSubGroupModel);
        });

        modifierGroupTotalPrice = modifierGroupTotalPrice + totalPrice * modifierModel.quantity
    });

    return modifierGroupTotalPrice;
}

module.exports.isItemModelFullySatisfied = function(itemModel)
{
    for (var index = 0; index < itemModel.modifierGroupModels.length; index++)
    {
        if (!this.isModifierGroupModelFullySatisfied(itemModel.modifierGroupModels[index]))
            return false;
    }
    return true;
}

module.exports.isModifierGroupModelFullySatisfied = function(modifierGroupModel)
{
    var selectedQuantity = 0;
    for (var index = 0; index < modifierGroupModel.modifierModels.length; index++)
    {
        var modifierModel = modifierGroupModel.modifierModels[index];
        if (modifierModel.quantity > 0 && !this.isItemModelFullySatisfied(modifierModel))
            return false;

        selectedQuantity = selectedQuantity + modifierModel.quantity;
    }
    return selectedQuantity >= modifierGroupModel.modifier.min;
}

module.exports.canSelectMoreModifiers = function(modifierGroupModel)
{
    var selectedQuantity = 0;
    modifierGroupModel.modifierModels.forEach(modifierModel =>
    {
        selectedQuantity = selectedQuantity + modifierModel.quantity;
    });

    return selectedQuantity < modifierGroupModel.modifier.max;
}


module.exports.multipleSelectionAllowedInModifierGroupModel = function(modifierGroupModel)
{
    return modifierGroupModel.modifier.canSameItemBeSelectedMultipleTimes;
}


module.exports.removeItemModel = function(itemModel)
{
    itemModel.quantity = 0;
    itemModel.modifierGroupModels.forEach (modifierGroupModel =>
    {
        this.removeModifierGroupModel(modifierGroupModel);
    });
}

module.exports.removeModifierGroupModel = function(modifierGroupModel)
{
    modifierGroupModel.modifierModels.forEach(modifierModel =>
    {
        this.removeItemModel(modifierModel);
    });
}


